import React, { FC, useState } from 'react';
import clsx from 'clsx';
import s from '../ProfileMenu.module.scss';
import ProfileMenuHeader from '../ProfileMenuHeader';
import ProfileMenuActions from '../ProfileMenuActions';
import GenderSelector from './GenderSelector';
import { Menu } from '../ProfileMenu'; 
import ModalTextButton from './ModalTextButton';
import useUser from 'sdk/hooks/user/useProfile';
import useLogout from 'sdk/hooks/useLogout';
import { useNavigate } from 'react-router-dom';

type Props = {
  onClose: (menu: Menu) => void;
  closeAll?: () => void;
};

const UserSettings: FC<Props> = ({ onClose, closeAll }) => {
  const navigate = useNavigate();
  const logoutMutation = useLogout(navigate);
  const { data: profile } = useUser();

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);

  const handleClose = () => {
    onClose(Menu.PROFILE);
  };

  const openDeleteModal = () => {
    setIsDeleteModalOpen(true);
  };

  const handleDeleteAccount = async () => {
    
    const user_id = profile?.id;

     logoutMutation.mutate(); 

    if (!user_id) {
      console.error('User not logged in');
      return;
    }

    try {
      const response = await fetch('https://gibnkggiuxphkienkxwf.supabase.co/functions/v1/delete-account', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ user_id }),
      });

      const result = await response.json();

      if (!response.ok) {
        console.error('Ошибка при удалении:', result.error);
        return;
      }

     
    } catch (err) {
      console.error('Network error:', err);
    }
  };

  return (
    <div className={s.user_settings}>
      <ModalTextButton
        visible={isDeleteModalOpen}
        title="Delete your Account"
        subtitle="Are you sure? We will miss you!"
        buttonName="Delete permanently"
        buttonColor="red"
        onClick={handleDeleteAccount}
        onClose={() => setIsDeleteModalOpen(false)}
      />
      <div className={s.menu__inner}>
        <ProfileMenuHeader text="User Settings" onClose={handleClose} />
        <GenderSelector />
      </div>
  
      <div className={clsx(s.menu__inner, s.profile_menu_actions)}>
        <ProfileMenuActions onClose={closeAll} onDeleteAccount={openDeleteModal} />

      </div>
   
    </div>
  );
};

export default UserSettings;
